// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module_container__WKiWja4QcyPGzGHokROg-"};